/**
 * A subtle horizontal divider styled like a baseball seam: a thin red dotted line
 * at low opacity. Used sparingly as a section break.
 */
export function SeamDivider({ className = "" }) {
  return (
    <div
      role="presentation"
      aria-hidden="true"
      data-testid="seam-divider"
      className={`mx-auto h-px w-full max-w-3xl ${className}`}
      style={{
        backgroundImage:
          "radial-gradient(circle, rgba(200,16,46,0.5) 1px, transparent 1.4px)",
        backgroundSize: "10px 2px",
        backgroundRepeat: "repeat-x",
        backgroundPosition: "center",
      }}
    />
  );
}
